import api from './api';

interface StageSummaryEntry {
  time?: string;
  temp?: number | string;
}

interface WeightAnalysis {
  shrinkagePercent?: number;
  totalTimeMinutes?: number;
  inputWeight?: number;
  outputWeight?: number;
}

interface AgtronDTO {
  wholeBean?: number;
  groundBean?: number;
  classification?: {
    scaa?: string;
    common?: string;
  };
}

interface WorkOrderRecipeStageDTO {
  time_seconds: number;
  temperature: number | null;
  fire?: number | null;
  airflow?: number | null;
  air_temp?: number | null;
  drum_temp?: number | null;
  environment_temp?: number | null;
  drum_rpm?: number | null;
  sequence_order: number;
}

export interface WorkOrderRecipeDTO {
  id: string;
  work_order_id?: string | null;
  reference_id?: string | null;
  roast_type?: string | null;
  input_weight?: number | null;
  output_weight?: number | null;
  agtron?: AgtronDTO | null;
  stage_summary?: Record<string, StageSummaryEntry> | null;
  weight_analysis?: WeightAnalysis | null;
  stages?: WorkOrderRecipeStageDTO[] | null;
  profile?: unknown;
}

export interface InventoryRoastProfileSavePayload {
  workOrderId?: string;
  referenceId?: string;
  roastType?: string;
  weightInput?: number;
  weightOutput?: number;
  agtron?: AgtronDTO;
  stageSummary?: Record<string, StageSummaryEntry>;
  profile?: unknown;
  weightAnalysis?: WeightAnalysis;
}

export interface CreateRecipeData {
  name: string;
  description?: string;
  itemId: string;
  machineId: string;
  roastType: string;
}
export const workOrderRecipeService = {
  async getByWorkOrderId(workOrderId: string): Promise<WorkOrderRecipeDTO | null> {
    if (!workOrderId) return null;
    const response = await api.get<WorkOrderRecipeDTO | null>('/work-orders/recipes', {
      params: { work_order_id: workOrderId },
    });
    return response.data;
  },

  async getByReferenceId(referenceId: string): Promise<WorkOrderRecipeDTO | null> {
    if (!referenceId) return null;
    const response = await api.get<WorkOrderRecipeDTO | null>('/work-orders/recipes', {
      params: { reference_id: referenceId },
    });
    return response.data;
  },

  async create(payload: InventoryRoastProfileSavePayload): Promise<WorkOrderRecipeDTO> {
    const requestBody = {
      work_order_id: payload.workOrderId,
      reference_id: payload.referenceId,
      roast_type: payload.roastType,
      input_weight: payload.weightInput,
      output_weight: payload.weightOutput,
      agtron: payload.agtron,
      stage_summary: payload.stageSummary,
      profile: payload.profile,
      weight_analysis: payload.weightAnalysis,
    };

    const response = await api.post<WorkOrderRecipeDTO>('/work-orders/recipes', requestBody);
    return response.data;
  },

  async update(id: string, payload: InventoryRoastProfileSavePayload): Promise<WorkOrderRecipeDTO> {
    const requestBody = {
      work_order_id: payload.workOrderId,
      reference_id: payload.referenceId,
      roast_type: payload.roastType,
      input_weight: payload.weightInput,
      output_weight: payload.weightOutput,
      agtron: payload.agtron,
      stage_summary: payload.stageSummary,
      profile: payload.profile,
      weight_analysis: payload.weightAnalysis,
    };

    const response = await api.put<WorkOrderRecipeDTO>(`/work-orders/recipes/${id}`, requestBody);
    return response.data;
  },
};
